import axios from 'axios';

import AppStore from 'app/redux/store';
import AppConfig from 'config/AppConfig';
import * as NAVIGATION from 'config/navigation';


export const initAxiosLogin = async () => {
  const instance = axios.create({
    baseURL: `${AppConfig.apiRoot}`,
    headers: {
      "Content-Type": 'application/json',
    },
  });

  return instance;
};

export const initAxios = async () => {
  const state = AppStore.getState(); 
  const bearer = state.app.accessToken;
  const instance = axios.create({
    baseURL: `${AppConfig.apiRoot}`,
    headers: { Authorization: `Bearer ${bearer}` },
  });

  instance.interceptors.response.use(
    (response) => response,
    async (error) => {
      if (error.response?.status === 428) {
        window.location.href = NAVIGATION.CHANGE_PASSWORD;
        return Promise.reject(error);
      }
      if (error.response?.status === 401 || error.response?.status === 403) {
        localStorage.clear();
        window.location.href = NAVIGATION.LOGIN;
        return Promise.reject(error);
      }

      return Promise.reject(error);
    }
  );

  return instance;
};

export const initAxiosDownload = async () => {
  const state = AppStore.getState();
  const bearer = state.app.accessToken;
  const instance = axios.create({
    baseURL: `${AppConfig.apiRoot}`,
    responseType: 'blob',
    headers: {
      Authorization: `Bearer ${bearer}`,
      Accept: 'application/pdf, application/json;q=0.9, */*;q=0.8',
    },
  });

  instance.interceptors.response.use(
    (response) => response,
    async (error) => {
      if (error.response?.status === 428) {
        window.location.href = NAVIGATION.CHANGE_PASSWORD;
        return Promise.reject(error);
      }
      if (error.response?.status === 401) {
        localStorage.clear();
        window.location.href = NAVIGATION.LOGIN;
      }

      return Promise.reject(error);
    }
  );

  return instance;
};
